export default {"src":"/planos/_next/static/media/equifax-calendar-time.fd074e3e.svg","height":27,"width":25,"blurWidth":0,"blurHeight":0};